module.exports = __webpack_public_path__ + "dist/banner_02.bfd370e0.png";